export const APP_REDIRECT_ROUTES = [
  { path: '/briefing', to: '/' },
  { path: '/admin/email-templates', to: '/documents' },

  // Former standalone admin pages now live inside consolidated admin surfaces.
  { path: '/admin/ai-profiles', to: '/admin/ai/rules' },
  { path: '/admin/case-patterns', to: '/admin/ai/rules' },
  { path: '/admin/pattern-dashboard', to: '/admin/ai/rules' },
  { path: '/admin/respa-settings', to: '/admin/ai/rules' },
  { path: '/admin/fcra-settings', to: '/admin/ai/rules' },
  { path: '/admin/automations', to: '/admin/rules-engine' },
  { path: '/admin/journey-rules', to: '/admin/rules-engine?tab=journey' },
  { path: '/admin/escalation-rules', to: '/admin/rules-engine?tab=escalation' },
  { path: '/admin/task-bundles', to: '/admin/task-templates' },
  { path: '/admin/recurring-tasks', to: '/admin/task-templates?tab=recurring' },
  { path: '/admin/retainer-rules', to: '/admin/retainers' },
  { path: '/admin/retainer-builder', to: '/admin/retainers?tab=builder' },
  { path: '/admin/compliance-rules', to: '/admin/operations?tab=compliance' },
  { path: '/admin/outbound-notifications', to: '/admin/operations?tab=notifications' },
  { path: '/admin/file-intake', to: '/admin/ai/file-processing' },
  { path: '/admin/court-docs', to: '/admin/ai/file-processing' },
  { path: '/admin/ai-inbox', to: '/admin/ai/file-processing' },
  { path: '/admin/embeddings', to: '/admin/ai/dashboard' },

  // Public/staff aliases retained for bookmarks and old documentation links.
  { path: '/kpis', to: '/admin/kpis' },
  { path: '/kpis/alerts', to: '/admin/kpis/alerts' },
  { path: '/kpis/guide', to: '/admin/kpis/guide' },
  { path: '/portal', to: '/staff-portal' },
  { path: '/portal/:tab', to: '/staff-portal' },
  { path: '/library', to: '/staff-portal' },
  { path: '/research', to: '/staff-portal/research' },
  { path: '/ask', to: '/staff-portal/ask' },
  { path: '/my-tasks', to: '/ai-hub' },
  { path: '/time-clock', to: '/staff-portal/time-clock' },
  { path: '/portal-queue', to: '/' },
  { path: '/pipeline-monitor', to: '/' },
  { path: '/protocols', to: '/staff-portal/protocols' },
  { path: '/protocols/:slug', to: '/staff-portal/protocols' },
  { path: '/evidence-escalations', to: '/documents?tab=evidence-escalations' },
  { path: '/dashboard', to: '/' },
  { path: '*', to: '/' },
] as const;
